export const GET_TEAM_ACCOUNT_CUSTOMER = teamId => `{
    team(teamId: "${teamId}") {
      name
      account {
        id
        ownerId
        updatedAt
        customerId
        name
        createdAt
        tier
        cycle
        alwaysFree
        customer {
            id
            stripePlanId
            ccLast_4
            ccExpDate
            ccBrand
            createdAt
            updatedAt
            paymentStatus
            trialEnd
            trialEndTs
            customerPayments {
                id
                stripeChargeId
                stripeInvoiceID
                stripeInvoiceNumber
                paymentMethod
                customerId
                amount
                createdAt
                updatedAt
          }
        }
      }
    }
  }`

export const GET_ACCOUNT_CUSTOMER = accountId => `{
    account(accountId: "${accountId}") {
        id
        ownerId
        updatedAt
        customerId
        name
        createdAt
        tier
        cycle
        alwaysFree
        customer {
            id
            stripePlanId
            ccLast_4
            ccExpDate
            ccBrand
            createdAt
            updatedAt
            paymentStatus
            trialEnd
            trialEndTs
            customerPayments {
                id
                stripeChargeId
                stripeInvoiceID
                stripeInvoiceNumber
                paymentMethod
                customerId
                amount
                createdAt
                updatedAt
            }
        }
    }
}`



// WEBPACK FOOTER //
// ./src/util/customer_graphql_queries.js